import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";

const ModalHeader = ({type = 'simple', header, icon = '', customClassnames = ''}) => {
  switch (type) {
    case 'complex':
      return (
        <div className={classNames(styles.complexHeader, customClassnames)}>
          <div className={styles.iconContainer}>
            <img src={toAbsoluteUrl(icon)} alt="icon" className={styles.icon}/>
          </div>
          <div className={styles.text}>{header}</div>
        </div>
      );
    case 'simple':
    default:
      return (
        <h3 className={classNames(styles.simpleHeader, customClassnames)}>
          {header}
        </h3>
      );
  }
};

export default ModalHeader;